var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCouponBgImg01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 290 60"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#black",
  d: "M290 25a5 5 0 0 0 0 10v25H0V0h290z"
})));
export default SvgCouponBgImg01;